import { USER_ROLES } from 'consts'

type UserRoleKey = keyof typeof USER_ROLES

export function getUserRoleName(roleNumber: number): UserRoleKey | 'GUEST' {
  return (Object.entries(USER_ROLES).find(([_, value]) => value === roleNumber)?.[0] as UserRoleKey) || 'GUEST'
}
